export default {
  methods: {
    paginationPages (margin = 0, page = 1, total = 1) {
      const result = [];
      for ( let i = (page - margin < 1 ? 1 : page - margin); i <= (page + margin > total ? total : page + margin); i++) {
        result.push(i);
      }
      return result;
    },
    paginationUrl (base = '', page = 1, param = '/page=') {
      if (!base.length || base === '') return 'javascript:{}';
      return (this.rootPathname + '/' || '') + base + (page > 1 ? param + page : '');
    },
    paginationLoadMore() {},
  }
};
